import { type Event, type EventParticipant, isRegisteredEventParticipant } from 'models';
import { Avatar, Button, Col, Dropdown, Icon, type MenuProps, Row, Text } from 'ui';
import { useUser } from 'features/auth';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { AvatarLink, UserLink, UserPopover } from 'features/users/components';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { useGetNodeUserAvatar } from 'features/users/hooks';
import { EventInviteeName, EventInviteesListRow } from '../../../../../../components';

type P = {
  event: Event;
  getInviteesActions: (params: { currentInvitee: EventParticipant; event: Event }) => MenuProps['items'];
  isLoadingAction: boolean;
  participant: EventParticipant;
};

const EventInvitee = ({ event, getInviteesActions, isLoadingAction, participant }: P) => {
  const { nodeUserData: nodeViewer } = useUser();
  const actions = getInviteesActions({ currentInvitee: participant, event }) ?? [];
  const getAvatarUrl = useGetNodeUserAvatar();
  const profilePhoto = isRegisteredEventParticipant(participant)
    ? getAvatarUrl({ size: 'medium', userId: participant.ref })
    : undefined;

  return (
    <EventInviteesListRow key={participant.ref}>
      <Col>
        {isRegisteredEventParticipant(participant) ? (
          <UserPopover fallback={{ ...participant, profilePhoto }} userId={participant.ref}>
            <AvatarLink
              avatar={{
                src: profilePhoto,
              }}
              userId={participant.ref}
            />
          </UserPopover>
        ) : (
          <Avatar />
        )}
      </Col>
      <Col flex="1 1 0">
        <Row>
          <Col span={24}>
            {isRegisteredEventParticipant(participant) ? (
              <UserPopover fallback={{ ...participant, profilePhoto }} userId={participant.ref}>
                <UserLink userId={participant.ref}>
                  <EventInviteeName invitee={{ ...participant, id: participant.ref }} viewerId={nodeViewer._id} />
                </UserLink>
              </UserPopover>
            ) : (
              <Text type="title" weight="medium">
                {participant.email}
              </Text>
            )}
          </Col>
          <Col span={24}>
            <Text size="small">{participant.email}</Text>
          </Col>
        </Row>
      </Col>
      {actions.length > 0 ? (
        <Col>
          <Dropdown
            menu={{
              items: actions,
            }}
            trigger={['click']}
          >
            <Button icon={<Icon color="text" icon="more-2-line" />} loading={isLoadingAction} type="link-secondary" />
          </Dropdown>
        </Col>
      ) : null}
    </EventInviteesListRow>
  );
};

export default EventInvitee;
